import { Row, Button, Col, AutoComplete, Form, Alert } from 'antd';
import capitalize from 'components/utils/capitalize';
import deepEqual from 'components/utils/deepEqual';
import React, { useEffect, useState } from 'react';
import { MappingChoice } from 'services/hitchit/types/Choices';

type Option = {
  label: string;
  value: string;
};

const ConfigureMappingField = ({
  choice,
  preference,
  savedPreference,
  onChange,
  onReset,
  onClear,
  onSave,
  onCancel,
}: {
  choice: MappingChoice;
  preference?: Record<string, string>;
  savedPreference?: Record<string, string>;
  onChange: (choice: Record<string, string> | undefined) => void;
  onReset: () => void;
  onClear: () => void;
  onCancel: () => void;
  onSave: () => void;
}): JSX.Element => {
  const isRequired = choice?.required && !preference;

  const [optionsFrom, setOptionsFrom] = useState<Option[]>();

  useEffect(() => {
    if (choice) {
      setOptionsFrom([...choice.choices.to.map(({ label, id }) => ({ label, value: id }))]);
    }
  }, [choice]);

  const onChangeLocal = (query: Record<string, string>) => {
    onChange({
      ...(preference || {}),
      ...query,
    });
  };

  return (
    <Row gutter={[8, 8]} style={{ textAlign: 'left' }}>
      {choice.choices.from.map(({ label, id }) => (
        <Col key={id} md={12} sm={24}>
          <Col>
            <p>{capitalize(label)}:</p>
          </Col>
          <Col>
            <Form.Item
              validateStatus={isRequired ? 'error' : ''}
              help={isRequired ? 'Required' : ''}
            >
              <AutoComplete
                allowClear
                style={{ width: 200 }}
                placeholder={choice?.label}
                options={optionsFrom}
                value={
                  preference && preference[id] && optionsFrom
                    ? optionsFrom.find((option) => option.value === preference[id])?.label
                    : ''
                }
                onChange={(value) => {
                  onChangeLocal({ [id]: value });
                }}
                filterOption={(inputValue, option) => {
                  return (
                    !!option?.label &&
                    (option.label as string).toLowerCase().indexOf(inputValue.toLowerCase()) !== -1
                  );
                }}
              />
            </Form.Item>
          </Col>
        </Col>
      ))}
      {choice.infoText && (
        <Col>
          <Alert
            style={{ padding: 16, margin: 16 }}
            message={choice.infoText}
            type="info"
            showIcon
          />
        </Col>
      )}
      <Col>
        <Button type="primary" disabled={deepEqual(savedPreference, preference)} onClick={onSave}>
          Save changes
        </Button>
      </Col>
      <Col>
        <Button disabled={deepEqual(savedPreference, preference)} type="ghost" onClick={onCancel}>
          Cancel change
        </Button>
      </Col>
      {choice.default && (
        <Col>
          <Button type="ghost" onClick={onReset}>
            Pick default
          </Button>
        </Col>
      )}
      <Col>
        <Button type="ghost" onClick={onClear}>
          Clear
        </Button>
      </Col>
    </Row>
  );
};

export default ConfigureMappingField;
